var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header__search--div"},[_c('div',{staticClass:"header__content"},[_c('a-input-search',{staticClass:"header__input",attrs:{"placeholder":"请输入关键词或者产品名称","enter-button":"搜索","size":"large"},on:{"search":_vm.onSearch}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }